//@flow

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Alert, Button } from 'reactstrap';
import {
  openLoginModal,
  loginSessionExpire,
  logout,
} from '../../redux/actions/authActions';
import { hasTokenExpired } from '../../lib/utils';

type Props = {
  openLoginModal: Function,
  loginSessionExpire: Function,
  hasSessionExpired: boolean,
  isUserLoggedIn: boolean,
};

class LoginSessionExpire extends Component<Props> {
  componentDidMount() {
    const { loginSessionExpire, hasSessionExpired, logout } = this.props;

    if (hasTokenExpired()) {
      if (!hasSessionExpired) logout();
    } else {
      if (hasSessionExpired) loginSessionExpire(false);
    }
  }

  render() {
    const { hasSessionExpired, openLoginModal, isUserLoggedIn } = this.props;

    return (
      <div className="cookies">
        {!isUserLoggedIn && (
          <Alert color="cookie" isOpen={hasSessionExpired}>
            {'Your session has expired. Please Login again to continue.'}
            <Button color="yellow" size="sm" onClick={() => openLoginModal()}>
              Login
            </Button>
          </Alert>
        )}
      </div>
    );
  }
}

export default connect(
  ({ user }) => ({
    hasSessionExpired: user.hasSessionExpired,
    isUserLoggedIn: Boolean(user.userId),
  }),
  {
    openLoginModal,
    loginSessionExpire,
    logout,
  }
)(LoginSessionExpire);



// WEBPACK FOOTER //
// ./src/screens/LoginSessionExpire/LoginSessionExpire.jsx